import { Button, Dialog, Spinner, Text } from '@risksmart-app/atomic-ui';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { WebhookPart } from 'src/contracts/querySelections';

interface Props {
  webhook: WebhookPart | null;
  loading: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

const SendTestEventModal: FC<Props> = ({
  webhook,
  loading,
  onConfirm,
  onDismiss,
}) => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'webhooks.send_test_modal',
  });

  return (
    <Dialog
      open={webhook !== null}
      onOpenChange={(open) => {
        if (!open && !loading) {
          onDismiss();
        }
      }}
      size={'md'}
    >
      <Dialog.Header title={t('title')} />
      <Dialog.Body>
        <Text preset={'body-md'}>{t('body')}</Text>
      </Dialog.Body>
      <Dialog.Footer>
        <Button variant={'default'} onClick={onConfirm} disabled={loading}>
          {loading && <Spinner size={'sm'} />}
          {t('confirm_button')}
        </Button>
        <Button
          variant={'neutral'}
          style={'outline'}
          onClick={onDismiss}
          disabled={loading}
        >
          {t('cancel_button')}
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};

export default SendTestEventModal;
